<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card elevation="4" class="rounded-sm">
          <v-card-title>
            <div class="text-subtitle-1 font-weight-bold">Información general</div>
          </v-card-title>
          <v-card-text>
            <InformacionGeneralEvaluacionSection :evaluacion="disciplinaAdministrativa" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <TiposIncidenciaForm :incidencias="disciplinaAdministrativa.incidencias" :readonly="readonly" />
      </v-col>
      <v-col>
        <ActasAdministrativasForm
          :actas-administrativas="disciplinaAdministrativa.actasAdministrativas"
          :readonly="readonly"
        />
      </v-col>
      <v-col>
        <EstimulosForm :estimulos="disciplinaAdministrativa.estimulos" :readonly="readonly" />
      </v-col>
      <v-col>
        <ReconocimientosForm :reconocimientos="disciplinaAdministrativa.reconocimientos" :readonly="readonly" />
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn
          v-if="!readonly"
          color="secondary"
          @click="triggerSaveDisciplinaAdministrativa()"
          :loading="loading"
          :disabled="loading"
          >Guardar evaluación</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UpdateEvaluacionDisciplinaAdministrativaUseCase from '@/modules/evaluacion-desempeño/application/usecases/UpdateEvaluacionDisciplinaAdministrativa.usecase'
import InformacionGeneralEvaluacionSection from '../common/InformacionGeneralEvaluacionSection.vue'
import ActasAdministrativasForm from '../disciplina-administrativa/forms/ActasAdministrativasForm.vue'
import EstimulosForm from '../disciplina-administrativa/forms/EstimulosForm.vue'
import ReconocimientosForm from '../disciplina-administrativa/forms/ReconocimientosForm.vue'
import TiposIncidenciaForm from '../disciplina-administrativa/forms/TiposIncidenciaForm.vue'
import EvaluacionDisciplinaAdministrativaApiRepository from '@/modules/evaluacion-desempeño/infrastructure/EvaluacionDisciplinaAdministrativaApi.repository'
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    InformacionGeneralEvaluacionSection,
    TiposIncidenciaForm,
    ActasAdministrativasForm,
    EstimulosForm,
    ReconocimientosForm,
  },

  data() {
    return { loading: false }
  },

  computed: {
    ...mapGetters('disciplinaAdministrativa', { disciplinaAdministrativa: 'getSelectedDisciplinaAdministrativa' }),
  },

  methods: {
    ...mapMutations('dialog', ['CLOSE_DIALOG']),

    async triggerSaveDisciplinaAdministrativa() {
      this.loading = true

      try {
        await new UpdateEvaluacionDisciplinaAdministrativaUseCase(
          new EvaluacionDisciplinaAdministrativaApiRepository()
        ).execute(this.disciplinaAdministrativa)

        this.CLOSE_DIALOG()
      } catch (error) {
        console.error('Error al guardar la evaluación de disciplina administrativa:', error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
